import "./BankDetailsModal.css";

export default function BankDetailsModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className={`bank-details-modal-overlay ${isOpen ? "open" : ""}`} onClick={onClose}>
      <div className="bank-details-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="bank-details-modal-close" onClick={onClose} aria-label="Close">
          &times;
        </button>
        <div className="bank-details-modal-body">
          <h2 className="bank-details-modal-title">
            Your bank details have been saved and will be used for payments.
          </h2>
          <div className="bank-details-modal-icon-container">
            <img
              src="/bank-details-success-shield.png"
              alt="Security Shield Icon"
              className="bank-details-modal-shield-icon"
            />
          </div>
          <p className="bank-details-modal-subtitle">
            You can edit these details anytime in your profile settings.
          </p>
        </div>
      </div>
    </div>
  );
}
